module.exports = __webpack_public_path__ + "img/dang1.cd6caa11.png";